import axios from 'axios';

export async function getSettings() {
  return axios.get('/api/settings');
}

export const getAppSettings = async () => {
  try {
    return await axios.get('/api/settings/app');
  } catch (error) {
    console.error('Error fetching app settings:', error);
    // prevents error on the homepage
    return { data: {} };
  }
};